import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import isEmpty from 'lodash/isEmpty';
import { bindActionCreators } from 'redux';
import isEqual from 'lodash/isEqual';
import find from 'lodash/find';
import get from 'lodash/get';
import PaymentMethodsList from 'yoda-checkout-components/lib/components/PaymentMethodsList/PaymentMethodsList';
import OrderTotal from 'yoda-checkout-components/lib/components/OrderTotal/OrderTotal';
import PricingSummary from 'yoda-checkout-components/lib/components/PricingSummary/PricingSummary';
import PlaceOrderButton from 'yoda-checkout-components/lib/components/PlaceOrderButton/PlaceOrderButton';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { ADJUSTMENT_TYPE_FREE_SHIP } from 'yoda-checkout-components/lib/common/Constants';
import {
    isAgentLogged,
    isSentToAgencyFromCart,
} from 'yoda-core-components/lib/helpers/Utils/Utils';
import * as styles from './OrderSummary.css';
import ExpressCheckoutAction from '../../actions/ExpressCheckoutAction';
// eslint-disable-next-line import/no-named-as-default
import ExpressCheckout from '../../containers/Pages/Review/components/ExpressCheckout/ExpressCheckout';
import { selectBnplOnOrder } from '../../selectors/NewPaymentMethodSelector';
import VoucherNumberForm from '../../containers/Pages/NewPaymentPage/VoucherNumberForm/VoucherNumberForm';

const cx = classNames.bind(styles);

export class OrderSummary extends Component {
    static propTypes = {
        orderDetails: PropTypes.arrayOf(PropTypes.object),
        orderInfo: PropTypes.objectOf(PropTypes.object),
        orderCharges: PropTypes.arrayOf(PropTypes.object),
        alternateChargeInfo: PropTypes.arrayOf(PropTypes.object),
        orderAdjustments: PropTypes.arrayOf(PropTypes.object),
        orderTotals: PropTypes.objectOf(PropTypes.object),
        orderPaymentInfo: PropTypes.arrayOf(PropTypes.object),
        showPlaceOrderButton: PropTypes.bool,
        submitForApproval: PropTypes.bool,
        orderItems: PropTypes.arrayOf(PropTypes.object),
        isShowCouponPricing: PropTypes.bool,
        context: PropTypes.objectOf(PropTypes.object).isRequired,
        expressCheckoutInfo: PropTypes.objectOf(PropTypes.object),
        showOrderSummaryTitle: PropTypes.objectOf(PropTypes.object),
        isBnplOnOrder: PropTypes.bool,
    };

    static defaultProps = {
        orderInfo: {},
        orderCharges: [],
        alternateChargeInfo: {},
        orderAdjustments: [],
        orderTotals: {},
        orderPaymentInfo: [],
        orderItems: [],
        showPlaceOrderButton: false,
        submitForApproval: false,
        isShowCouponPricing: false,
        orderDetails: {},
        expressCheckoutInfo: {},
        showOrderSummaryTitle: false,
        isBnplOnOrder: false,
    };

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    renderPaymentDetails() {
        const { orderDetails } = this.props;
        const isPriceAccurate = get(orderDetails, 'data.isPriceAccurate', false);
        const sentToAgency = isSentToAgencyFromCart(this.props.context);
        return (this.props.orderInfo &&
            this.props.orderInfo.status &&
            this.props.orderInfo.status.code === 'DRAFT') ||
            sentToAgency ? (
            ''
        ) : (
            <PaymentMethodsList
                isPriceAccurate={isPriceAccurate}
                paymentMethodsInfo={this.props.orderPaymentInfo}
                context={this.props.context}
            />
        );
    }

    render() {
        if (this.props.orderInfo && isEmpty(this.props.orderInfo.status)) {
            return null;
        }
        const b2bContext = this.props.context;
        const {
            orderCharges,
            orderAdjustments,
            orderTotals,
            orderInfo,
            orderItems,
            alternateChargeInfo,
            isShowCouponPricing,
            showPlaceOrderButton,
            hideVoucherNumberFromConformation,
            submitForApproval,
            expressCheckoutInfo: {
                displayExpressCheckout,
                addressExpressCheckout,
                paymentExpressCheckout,
            },
            showOrderSummaryTitle,
            isBnplOnOrder,
        } = this.props;
        let charges = Object.assign([], orderCharges);
        let total = orderTotals['ORDER AMOUNT'];
        if (alternateChargeInfo.isDisplayAltCharges) {
            const stscharges = [];
            /* istanbul ignore else */
            if (!isEmpty(alternateChargeInfo.altCharges)) {
                const overSizeItem = find(alternateChargeInfo.altCharges, {
                    type: 'OVERSIZE SURCHARGE',
                });
                overSizeItem && stscharges.push(overSizeItem);
                const storeCharge = find(alternateChargeInfo.altCharges, { type: 'SHIP TO STORE' });
                const shippingAdjustments = find(orderAdjustments, {
                    description: ADJUSTMENT_TYPE_FREE_SHIP,
                });
                /* istanbul ignore else */
                if (shippingAdjustments && storeCharge) {
                    storeCharge.value = shippingAdjustments.value;
                    storeCharge.isCouponNotApplied = shippingAdjustments.amount === 0;
                }
                storeCharge && stscharges.push(storeCharge);
                const sthCharge = find(alternateChargeInfo.altCharges, { type: 'SHIP TO HOME' });
                sthCharge && stscharges.push(sthCharge);
                const taxCharge = find(alternateChargeInfo.altCharges, { type: 'TAX' });
                taxCharge.amount = taxCharge.amount === 0 ? 'TBD' : taxCharge.amount;
                taxCharge && stscharges.push(taxCharge);
            }
            charges = Object.assign([], stscharges);
            total = (find(alternateChargeInfo.altCharges, { type: 'ORDER AMOUNT' }) || {}).amount;
        }
        return (
            <section
                data-automation-id="at-order-summary-wrapper"
                className={`${cx('orderSummaryWrapper')} ${dt(['p-0'])}`}
                ref={(section) => {
                    this.scrollAnchor = section;
                }}
            >
                <div className={`${cx('orderSummaryRow')} ${dt(['m-0'])}`}>
                    {showOrderSummaryTitle && (
                        <div className={`${cx('col12', 'orderSummary')} ${dt(['!p-0'])}`}>
                            <p
                                className={`${cx('orderSummaryTitle')} ${dt([
                                    'text-xlarge',
                                    'font-open-sans-bold',
                                    'pb-2',
                                ])}`}
                                data-automation-id="at-order-summary-title"
                            >
                                Order Summary
                            </p>
                        </div>
                    )}
                    <span>
                        {this.renderPaymentDetails()}
                        <PricingSummary
                            orderPaymentInfo={this.props.orderPaymentInfo}
                            orderCharges={charges}
                            orderAdjustments={orderAdjustments}
                            orderSubTotal={orderTotals['SUB TOTAL']}
                            orderSubTotalAfterAdjustment={orderTotals['SUB TOTAL AFTER ADJUSTMENT']}
                            currency={orderInfo.currency}
                            orderStatus={orderInfo.status}
                            orderItems={orderItems}
                            isShowCouponPricing={isShowCouponPricing}
                            isCheckout
                        />
                        <OrderTotal
                            total={total}
                            items={orderInfo.itemsCount}
                            totalSavings={orderTotals.SAVINGS}
                            currency={orderInfo.currency}
                            noShadow
                            hideItems
                        />
                    </span>
                    {/* B2B voucher code */}
                    {(isSentToAgencyFromCart(b2bContext) ||
                        (isAgentLogged(b2bContext) && !showPlaceOrderButton)) &&
                        !hideVoucherNumberFromConformation && (
                            <VoucherNumberForm b2bVoucher={orderTotals?.voucherNumber || ''} />
                        )}
                    {!isBnplOnOrder &&
                    showPlaceOrderButton &&
                    displayExpressCheckout &&
                    !isAgentLogged(b2bContext) &&
                    !isSentToAgencyFromCart(b2bContext) ? (
                        <ExpressCheckout
                            paymentExpressCheckout={paymentExpressCheckout}
                            addressExpressCheckout={!addressExpressCheckout}
                        />
                    ) : (
                        ''
                    )}
                </div>
                {showPlaceOrderButton ? (
                    <PlaceOrderButton submitForApproval={submitForApproval} />
                ) : (
                    ''
                )}
            </section>
        );
    }
}

const mapStateToProps = (state) => ({
    orderInfo: state?.orderInfo,
    orderCharges: state?.orderCharges,
    orderAdjustments: state?.orderAdjustments,
    orderTotals: state?.orderTotals,
    orderPaymentInfo: state?.orderPaymentInfo,
    orderItems: state.orderItems,
    alternateChargeInfo: state?.alternateChargeInfo,
    context: state?.context,
    orderShippingGroupsInfo: state?.orderShippingGroupsInfo,
    orderDetails: state?.orderDetails,
    expressCheckoutInfo: state?.expressCheckoutInfo,
    isBnplOnOrder: selectBnplOnOrder(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...ExpressCheckoutAction }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummary);
